import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import SidebarDropdown from "../Dashboard/DashboardSidebar";

export default function MasterLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  

  return (
    <div className="master-layout">
      <Navbar 
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />

      <div className="dashboard-wrapper">
         <SidebarDropdown
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
        /> 

        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
